import React, { Component } from 'react';
import { isEmpty } from '../../../Common/Common';

export default class Display_Cell_Value extends Component {
	constructor(props) {
		super(props);

		this.state = {

		}
	}

	render() {
		let targetInfo = this.props.target_info;
		let data = this.props.data;
		let value_string = '';

		switch (targetInfo.type) {
			case 'totalEnergyMonthValue':
				if (data.hasOwnProperty('total_energy')) {
					value_string = data.total_energy.month;
				}
				break;
			case 'totalEnergyDayValue':
				if (data.hasOwnProperty('total_energy')) {
					value_string = data.total_energy.day;
				}
				break;
			case 'energyGenMonthValue':
				if (data.hasOwnProperty('energy_generator')) {
					value_string = data.energy_generator.month;
				}
				break;
			case 'energyGenDayValue':
				if (data.hasOwnProperty('energy_generator')) {
					value_string = data.energy_generator.day;
				}
				break;
			case 'waterConsumeMonthValue':
				if (data.hasOwnProperty('water_consumption')) {
					value_string = data.water_consumption.month;
				}
				break;
			case 'waterConsumeDayValue':
				if (data.hasOwnProperty('water_consumption')) {
					value_string = data.water_consumption.day;
				}
				break;
			case 'energyCatMonthValue':
				if (data.hasOwnProperty(targetInfo.id)) {
					value_string = data[targetInfo.id].month;
				}
				break;
			case 'energyCatDayValue':
				if (data.hasOwnProperty(targetInfo.id)) {
					value_string = data[targetInfo.id].day;
				}
				break;
			default:

		}

		let font_size = (0.133) * this.props.cell_width;

		return (
			<div style={{ display: 'inline-block', verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap' }}>
				<span style={{ fontSize: font_size }}>{value_string}</span>
			</div>
		)
	}
}